let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cjqXw")).then(() => parcelRequire('9cMeI'));